import { createSelector } from '@reduxjs/toolkit';

import { databaseSelector } from 'src/selectors/database';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';

export const isDatabaseRefreshedSelector = memoizeSelectorFactory(
  (databaseId: string | null) =>
    createSelector(
      databaseSelector(databaseId),
      (database) => database?.refreshed
    )
);
